import React from 'react';
import {Checkbox} from 'semantic-ui-react';

export const Employee = ({employee, setClickEmployeeName, onEmployeeSelect, setSelectedEmployee, setSelectedTeamClick, handleSeeEmployeeDetails}) => {
    let statusClass;
    switch (employee.status) {
        case 'invited':
            statusClass = 'employee-status-invited';
            break;
        case 'frozen':
            statusClass = 'employee-status-frozen';
            break;
        default: 
            statusClass = 'employee-status-active';
            break;
    }
    return (
        <tr key={employee.id} style={{fontStyle: 'SFProText-Medium', fontSize: 14, fontWeight: '500', backgroundColor: 'rgba(238, 241, 243, 1)'}}>
            <td style={{paddingTop: 15, paddingBottom: 15, borderTopWidth: 1}}><Checkbox style={{margin: 0}} onChange={() => onEmployeeSelect(employee.id, employee.selected)} checked={employee.selected} value={employee.id}/></td>
            <td style={{paddingTop: 15, paddingBottom: 15, borderTopWidth: 1}}>
                <div className="ui input">
                    {/*{editable ? (<input type="text" value={employeeName} onChange={e => setEmployeeName(e.target.value)}/>) : employeeName}*/}
                    {employee.name}
                </div>
            </td>
            <td className={statusClass} style={{paddingTop: 15, paddingBottom: 15, borderTopWidth: 1, color: employee.teamName === 'Unassigned' ? '#FCC65C' : ''}}>{employee.teamName}</td>
            <td style={{paddingTop: 15, paddingBottom: 15, borderTopWidth: 1}}>{employee.email}</td>
            {/*<td className={statusClass}>{status}</td>*/}
            <td style={{paddingTop: 15, paddingBottom: 15, borderTopWidth: 1, color: 'grey'}}><i className="angle right alternate icon"
                    // style = {{color: employee.teamId.length ? 'grey' : '#BEBEBE'}}
                    // disabled = {!employee.teamId.length}
                    onClick= {e => {
                        // if(employee.teamId.length>0)
                            handleSeeEmployeeDetails(employee.id)
                            // setSelectedEmployee(employee)
                        // setSelectedTeamClick(teamId)
                        // setClickEmployeeName(name)
                    }}
                    /></td>
        </tr>
    );
};
